import { RadioButton } from "primereact/radiobutton"
import { Controller } from "react-hook-form"

interface IRadioBtn {
    label?: string,
    name: string,
    defaultValue?: string | number,
    control: any,
    error?: string,
    required?: boolean,
    column?: number,
    data: Array<{ label: string, value: string | number | boolean }>,
    disabled?: boolean,
    inline?: boolean
}

export const JVRadioBtn = (props: IRadioBtn) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {!props.inline ?
                <>    {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}</>
                : ""}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {props.inline && <label className="mx-2">{props.label}</label>}
                {
                    props.data.map(data => {
                        return (
                            <div key={data.value.toString()} className="field-radiobutton mx-2 mt-1">
                                <Controller name={props.name} control={props.control} defaultValue={props.defaultValue ? props.defaultValue : ''} render={({ field }) => (
                                    <RadioButton {...field} disabled={props.disabled} checked={field.value === data.value} inputId={data.value.toString()} name={props.name} value={data.value} />
                                )} />
                                <label htmlFor={data.value.toString()}>{data.label}</label>
                            </div>
                        )
                    })
                }
            </div>
            <small className="p-error" >{props.error}</small>
        </div>
    )
}